"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodTypeEnum = void 0;
var PaymentMethodTypeEnum;
(function (PaymentMethodTypeEnum) {
    PaymentMethodTypeEnum["CardEntry"] = "Card Entry";
    PaymentMethodTypeEnum["CardReader"] = "Card Reader";
    PaymentMethodTypeEnum["Cash"] = "Cash";
    PaymentMethodTypeEnum["None"] = "None";
    PaymentMethodTypeEnum["Check"] = "Check";
})(PaymentMethodTypeEnum = exports.PaymentMethodTypeEnum || (exports.PaymentMethodTypeEnum = {}));
//# sourceMappingURL=PaymentMethodTypeEnum.js.map